<template>
	<button class="button is-square is-icon is-info has-background-dark" @click="$emit('input', !value)">
		<dp-svg :svg="svg" class="is-tiny" />
	</button>
</template>

<script>
import DpSvg from './dp-svg';

export default {
	name: 'DpLock',
	components: { DpSvg },
	props: {
		value: { type: Boolean, default: false },
	},
	computed: {
		svg() { return this.value ? 'statusLockOn' : 'statusLockOff'; },
	},
};
</script>
